export const getVisibleLfcDimensionsNames = (
  dimensions: any[],
  lfcDimensionsVisibilityJson: any[],
  lfcLanguage: string
): any[] =>
  dimensions.flatMap((dim) =>
    lfcDimensionsVisibilityJson.some(
      (ruleObj) =>
        ruleObj.dimensionCode === dim.dimensionCode && ruleObj.visibility === 'VISIBLE' && dim.values.length > 1 // note!
    )
      ? [dim[`dimensionName${lfcLanguage}`]]
      : []
  )
